<script lang="ts">
  import { onMount, createEventDispatcher } from "svelte";
  import {
    readAsArrayBuffer,
    readAsImage,
    readAsPDF,
    readAsDataURL,
  } from "./utils/asyncReader.js";
  import { save, getData, getPdfPageData } from "./utils/PDF.js";
  import Selectbox from "./Selectbox.svelte";
  import CopyClipBoard from "./CopyClipBoard.svelte";
  import CheckMark from "./CheckMark.svelte";
  import { buildSignUrl } from "./utils/signPublicUrl.js";

  const dispatch = createEventDispatcher();
  export let templates;
  export let blog;
  export let user;
  export let chatUsers;
  export let merusToken;
  export let fluentCaseToken;
  export let fluentCaseEnabled;
  export let merusCaseEnabled;
  export let tutorialStep = 0;
  export let tutorialNumber = 0;
  export let emailSubject;
  export let emailCC;
  export let friends;
  export let twilioEnabled = false;
  export let searchKeytemplate = "";
  let selectTemplateView = false;
  let packets = [];
  export let packetName = "";
  export let packetId = 0;
  export let templateIds = [];
  let selectedPacketId = "";
  let selectedPacketData: any = null;
  let selectedPacketName = "";
  let sharePacketView = false;
  let checkIfEmail = false;
  let sendPDFType = "";
  let shareEmail = "";
  let shareEmailPanel = false;
  let shareSMSPanel = false;
  let clipboardTxt = "";
  let shareCaseFileId = "";
  let matterId = "";
  let shareUserId = "";
  let shareUserName = "";
  let sending = false;
  let selectedTemplate = "";
  let multiplePdfs = [];
  let sendPDFRes = false;
  let selectedChatUser = "";
  let selectedSharepoint = "";
  onMount(async () => {
    getPackets();
    // displayTutorial(tutorialStep, tutorialNumber);
  });

  $: if (tutorialStep !== undefined) {
    displayTutorial(tutorialStep, tutorialNumber);
  }

  export async function displayTutorial(step, tutorialNum = 0) {
    tutorialNumber = tutorialNum;

    if (step === -1) {
      tutorialStep = (tutorialStep < 5) ? tutorialStep + 1 : 0;
    } else {
      tutorialStep = step;
    }
    switch (tutorialNumber) {
      case 0:
        break;
      case 1:
        break;
      case 2:
        break;
      case 3:
        createPacketTutorial(tutorialStep);
        break;
      case 4:
        break;
    }

  }
  async function createPacketTutorial(tutorialStep) {
    switch (tutorialStep) {
      case 3:
        // signatureMenu = true;
        // loadDefaultDoc(0);
        break;
      case 4:
        // showSignatureTabFunc();
        // changeSignatureTabFunc("templates");
        break;
      case 5:
        displayCreatePopup();

        break;
      case 6:
        displayCreatePopup();
        packetName = "Sample Packet";
        selectTemplate(templates[0]);
        break;
      case 7:
        displayCreatePopup();
        packetName = "Sample Packet";
        selectTemplate(templates[0]);
        updatePackets();
        break; 
      case 8:
        await getPackets();
        selectedPacket(packets[0]);
        break;
  
    }
  }

  
  function syncShareUserFromChat(chatUser) {
    if (!chatUser) return;
    if (chatUser.id != null && chatUser.id !== "") {
      shareUserId = chatUser.id;
    }
    if (chatUser.fullName) {
      shareUserName = chatUser.fullName;
    }
  }

  async function handleSendSMS(event) {
    const modifiedUser = event.detail.modifiedUser;
    if (modifiedUser) {
      // Update the selectedChatUser with the modified one (which has selected IDs only)
      selectedChatUser = modifiedUser;
      // Set the caseFileId and matterId from the modified user
      if (modifiedUser.advanced && modifiedUser.advanced.caseFileIds && modifiedUser.advanced.caseFileIds.length > 0) {
        shareCaseFileId = modifiedUser.advanced.caseFileIds[0];
      }
      if (modifiedUser.fluentCaseMattersIds && modifiedUser.fluentCaseMattersIds.length > 0) {
        matterId = modifiedUser.fluentCaseMattersIds[0];
      }
    }
    syncShareUserFromChat(modifiedUser || selectedChatUser);
    await sendSignature(0, 1, 1, "", "", emailCC);
    let res = await fetch("https://api.qix.cloud/message", {
      headers: {
        accept: "*/*",
        "accept-language": "en-US,en;q=0.9,ar;q=0.8",
        authorization:
          "Bearer " + localStorage.getItem("token"),
        "content-type": "application/json",
        "sec-ch-ua": '"Chromium";v="136", "Microsoft Edge";v="136", "Not.A/Brand";v="99"',
        "sec-ch-ua-mobile": "?0",
        "sec-ch-ua-platform": '"Windows"',
        "sec-fetch-dest": "empty",
        "sec-fetch-mode": "cors",
        "sec-fetch-site": "cross-site",
        Referer: "https://qixcloud-chat.pages.dev/",
        "Referrer-Policy": "strict-origin-when-cross-origin",
      },
      body: JSON.stringify({
        chat: selectedChatUser.id,
        message: emailSubject + "\n" + clipboardTxt,
        twilio: user.appId,
        sendToFileVine: false,
      }),
      method: "POST",
    });
  }

  async function getEmailSettings() {
    let body = { user_id: user.id };

    const req = await fetch(
      blog.siteurl + "/ajax/emailSettings.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
    emailSubject = res.sentEmailSubject != "" ? res.sentEmailSubject : "Hello [user_name], [staff_name] here with the document link / [company_name]";
    emailCC = res.cc != "" ? res.cc : "";
    return emailSubject;
  }

  async function updateEmailSettings() {
    let body = { user_id: user.id, sentEmailSubject: emailSubject, cc: emailCC, save: true };
    const req = await fetch(
      blog.siteurl + "/ajax/emailSettings.php",
      {
        method: "POST",
        body: JSON.stringify(body),
      }
    );
    let res = await req.json();
  }


  async function getPackets() {
    let body = new URLSearchParams();
    body.append("action", "getPackets");
    body.append("appId", user.appId);
    const req = await fetch(blog.siteurl + "/ajax/", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: body.toString(),
    });
    const data = await req.json();
    packets = Array.isArray(data) ? data : [];
  }
  async function updatePackets() {
    let body = new URLSearchParams();
    body.append("action", "updatePackets");
    body.append("appId", user.appId);
    body.append("packetName", packetName);
    body.append("packetId", packetId);
    body.append("templateIds", JSON.stringify(templateIds));
    const req = await fetch(blog.siteurl + "/ajax/", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: body.toString(),
    });
    const data = await req.json();
    packets = Array.isArray(data) ? data : [];
    selectTemplateView = false;
    
    // After updating, trigger the share flow
    selectedPacketData = {
      id: packetId,
      packetName: packetName,
      templateIds: JSON.stringify(templateIds)
    };
    selectedPacketId = packetId.toString();
    selectedPacketName = packetName;
    sharePacket();
    
    dispatch("expand", true);
    dispatch("packetUpdated");
  }
  async function editPacket(packet) {
    templateIds = JSON.parse(packet.templateIds);
    packetName = packet.packetName;
    packetId = packet.id;
    
    templates.forEach((data) => {
      if (templateIds.includes(data.id)) {
        data.selected = true;
      } else {
        data.selected = false;
      }
    });
    selectedTemplate = "";
    selectTemplateView = true;
    dispatch("expand", true);
  }
  async function deletePacket(id) {
    //Display a confirmation alert
    const deleteConfirmed = confirm(
      "Are you sure you want to Delete the Packet?"
    );

    if (deleteConfirmed) {
      let body = new URLSearchParams();
      body.append("action", "deletePacket");
      body.append("id", id);
      body.append("appId", user.appId);
      const req = await fetch(blog.siteurl + "/ajax/", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: body.toString(),
      });
      const data = await req.json();
      packets = Array.isArray(data) ? data : [];
    }
  }
  export function displayCreatePopup() {
    templateIds = [];
    packetName = "";
    packetId = 0;
    selectedPacketId = "";
    selectedPacketName = "";
    selectedPacketData = null;
    sharePacketView = false;
    if(templates){
      templates.forEach((data) => {
        data.selected = false;
      });
    }
    selectedTemplate = "";
    selectTemplateView = true;
    dispatch("expand", true);
  }

  export function editSelectedPacket(packet) {
    if (packet) {
      templateIds = JSON.parse(packet.templateIds);
      packetName = packet.packetName;
      packetId = packet.id;
      selectedPacketId = "";
      selectedPacketName = "";
      selectedPacketData = null;
      sharePacketView = false;
      templates.forEach((data) => {
        if (templateIds.includes(data.id)) {
          data.selected = true;
        } else {
          data.selected = false;
        }
      });
      selectedTemplate = "";
      selectTemplateView = true;
      dispatch("expand", true);
    }
  }

  // Reactive statement to handle prop changes from Template.svelte
  $: if (packetName && packetId && packetId > 0) {
    // Mark templates as selected/unselected based on templateIds
    templates.forEach((data) => {
      if (templateIds.includes(data.id)) {
        data.selected = true;
      } else {
        data.selected = false;
      }
    });
    
    // If we have packet data and we're not in selectTemplateView, trigger share
    if (!selectTemplateView) {
      // Create a packet object for sharing
      selectedPacketData = {
        id: packetId,
        packetName: packetName,
        templateIds: JSON.stringify(templateIds)
      };
      selectedPacketId = packetId.toString();
      selectedPacketName = packetName;
      sharePacket();
    }
  }
  function selectTemplate(template) {
    templateIds.push(template.id);
    template.selected = true;
    templates = templates.map((temp, tIndex) =>
      temp.id == template.id ? template : temp
    );
  }
  function unSelectTemplate(template) {
    templateIds = templateIds.filter((id) => id !== template.id);
    template.selected = false;
    templates = templates.map((temp, tIndex) =>
      temp.id == template.id ? template : temp
    );
  }

  function cancelPackets() {
    selectTemplateView = false;
    // Reset packet editing state
    packetName = "";
    packetId = 0;
    templateIds = [];
    selectedPacketId = "";
    selectedPacketName = "";
    selectedPacketData = null;
    sharePacketView = false;
    dispatch("expand", false);
    dispatch("select", []);
  }

  function resetShareSendState() {
    sendPDFRes = false;
    sending = false;
    clipboardTxt = "";
    selectedChatUser = "";
    shareEmail = "";
    shareUserId = "";
    shareUserName = "";
    shareCaseFileId = "";
    matterId = "";
    checkIfEmail = false;
  }

  function backToTemplates() {
    // Reset share success so user can start a new send from templates
    resetShareSendState();
    shareEmailPanel = false;
    shareSMSPanel = false;
    sendPDFType = "";
    // Reset all packet-related state to return to basic view
    packetName = "";
    packetId = 0;
    templateIds = [];
    selectedPacketId = "";
    selectedPacketName = "";
    selectedPacketData = null;
    sharePacketView = false;
    selectTemplateView = false;
    dispatch("expand", false);
    dispatch("select", []);
  }
  function selectedPacket(packet) {
    if (selectedPacketId == packet.id) {
      selectedPacketId = "";
      selectedPacketName = "";
      selectedPacketData = "";
      sharePacketView = false;
      dispatch("expand", false);
      dispatch("select", []);
    } else {
      selectedPacketId = packet.id;
      selectedPacketName = packet.packetName;
      selectedPacketData = packet;
      dispatch("select", JSON.parse(packet.templateIds));
    }
  }
  async function sharePacket() {
    sharePacketView = true;
    dispatch("expand", true);
  }

  function checkIfEmailFunc() {
    // Regular expression to check if string is email
    const regexExp =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;

    checkIfEmail = regexExp.test(shareEmail);
  }

  async function handleChatUserSelect(event) {
    selectedChatUser = event.detail.item;
    shareEmail = event.detail.item.email;
    if (event.detail.item.id != "") {
      shareUserId = event.detail.item.id;
      shareUserName = event.detail.item.fullName;
      shareCaseFileId = event.detail.item.advanced.caseFileIds.toString();
      // const matter = event.detail.item.tags.find(tag => tag.name === "matterId");
      // matterId = matter ? matter.id : "";
      if (event.detail.item.fluentCaseMattersIds && event.detail.item.fluentCaseMattersIds.length > 0) {
        matterId = event.detail.item.fluentCaseMattersIds[0].toString();
      }
    }
    checkIfEmailFunc();
  }
  async function handleChatUserEnterEmail(event) {
    shareEmail = event.detail.item.email;
    shareUserId = "";
    shareUserName = "";
    shareCaseFileId = "";
    checkIfEmailFunc();
  }

  function handleItemAdded(event) {
    const newItem = event.detail.item;
    // Add the new item to chatUsers if it doesn't already exist
    const existingIndex = chatUsers.findIndex(u => u.id === newItem.id);
    if (existingIndex === -1) {
      chatUsers = [...chatUsers, newItem];
    } else {
      // Update existing item
      chatUsers = chatUsers.map(u => u.id === newItem.id ? newItem : u);
    }
  }

  function handleItemUpdated(event) {
    const updated = event.detail?.item;
    if (!updated?.id) return;
    const existingIndex = chatUsers.findIndex((u) => u.id === updated.id);
    if (existingIndex === -1) {
      chatUsers = [...chatUsers, updated];
      return;
    }
    chatUsers = chatUsers.map((u) =>
      u.id === updated.id ? { ...u, ...updated, assignedTo: updated.assignedTo ?? u.assignedTo } : u
    );
  }

  async function sendSignatureHandle(type, event = null) {
    if (type == "link") {
      resetShareSendState();
      shareSMSPanel = false;
      shareEmailPanel = false;
      sendPDFType = "link";
      sendSignature(0);
    } else if (type == "email") {
      // Handle modifiedUser if provided (for multi-ID selection)
      if (event && event.detail && event.detail.modifiedUser) {
        const modifiedUser = event.detail.modifiedUser;
        // Update the selectedChatUser with the modified one (which has selected IDs only)
        selectedChatUser = modifiedUser;
        // Set the caseFileId and matterId from the modified user
        if (modifiedUser.advanced && modifiedUser.advanced.caseFileIds && modifiedUser.advanced.caseFileIds.length > 0) {
          shareCaseFileId = modifiedUser.advanced.caseFileIds[0];
        }
        if (modifiedUser.fluentCaseMattersIds && modifiedUser.fluentCaseMattersIds.length > 0) {
          matterId = modifiedUser.fluentCaseMattersIds[0];
        }
        syncShareUserFromChat(modifiedUser);
      }
      updateEmailSettings();
      sendPDFType = "email";
      sendSignature(0, 1, 1, "", shareEmail, emailCC);
    }
    else if (type == "sms") {
      sendPDFType = "sms";
      handleSendSMS(event);
    }
  }

  async function showShareEmailPanel() {
    resetShareSendState();
    shareSMSPanel = false;
    await getEmailSettings();
    shareEmailPanel = true;
    sendPDFType = "email";
  }

  async function showShareSMSPanel() {
    resetShareSendState();
    shareEmailPanel = false;
    shareSMSPanel = true;
    emailSubject = "";
    sendPDFType = "sms";
  }

  async function getSignatureOptions() {
    let initPageNum = 0;

    let sign1 = "";
    let sign2 = "";
    let sign3 = "";
    let sign4 = "";
    let sign5 = "";
    let sign6 = "";
    let firstPdfData = "";
    let firstAllObjects = "";
    let tempIds = JSON.parse(selectedPacketData.templateIds);
    selectedSharepoint = "";
    for (const template of templates) {
      if (tempIds.includes(template.id)) {
        if (selectedTemplate === "") {
          selectedTemplate = template;
        }

        if (selectedSharepoint === "") {
          selectedSharepoint = template.sharepoint || "";
        }

        const body = { url: template.pdfUrl, auth: "google" };
        try {
          const res = await fetch(
            `${blog.siteurl}/wp-admin/admin-ajax.php?action=loadTemplateCloudFlare`,
            {
              method: "POST",
              body: JSON.stringify(body),
            }
          );

          const pdfBlob = await res.blob();
          const pdf = await readAsPDF(pdfBlob);
          const pdfName = template.pdfName;
          const numPages = pdf.numPages;
          multiplePdfs.push({
            id: template.id,
            name: template.pdfName,
            pages: initPageNum + numPages,
            url: template.pdfUrl,
            allObjects: template.allObjects,
          });
          let allObjects = JSON.parse(template.allObjects || '[]');
          if (!Array.isArray(allObjects)) allObjects = [];
          while (allObjects.length < numPages) allObjects.push([]);
          if (firstAllObjects == "") firstAllObjects = allObjects;
          const pagesScale = Array(numPages).fill(1);

          try {
            const prePdfData = await getData(
              pdfBlob,
              allObjects,
              pdfName,
              pagesScale
            );
            let pdfData = prePdfData[0];
            if (firstPdfData == "") firstPdfData = pdfData;
            let optionData = prePdfData[1];

            for (let i = 0; i < optionData.length; i++) {
              const pageNum = optionData[i].pageIndex + 1 + initPageNum;
              let pageWidth = optionData[i].pageWidth;
              let pageHeight = optionData[i].pageHeight;
              let size = optionData[i].size;

              if (pageWidth === 792 && pageHeight === 612) {
                if (
                  optionData[0].pageWidth === 612 &&
                  optionData[0].pageHeight === 792
                ) {
                  pageWidth = 612;
                  pageHeight = 792;
                }
              }

              let posX = optionData[i].x / pageWidth;
              let posY =
                optionData[i].type === "text"
                  ? (optionData[i].y + 15) / pageHeight
                  : optionData[i].y / (pageHeight - 23);

              if (optionData[i].type === "text") {
                if (optionData[i].text === "Initial") {
                  sign2 += sign2
                    ? `,${pageNum}:${posX}:${posY}:${size}`
                    : `${pageNum}:${posX}:${posY}:${size}`;
                } else if (optionData[i].text === "Date") {
                  sign3 += sign3
                    ? `,${pageNum}:${posX}:${posY}:${size}`
                    : `${pageNum}:${posX}:${posY}:${size}`;
                } else if (optionData[i].text === "Name") {
                  sign4 += sign4
                    ? `,${pageNum}:${posX}:${posY}:${size}`
                    : `${pageNum}:${posX}:${posY}:${size}`;
                } else {
                  const text = optionData[i].text
                    .replace(/,/g, "-*-")
                    .replace(/:/g, "_*_");
                  sign5 += sign5
                    ? `,${pageNum}:${posX}:${posY}:${text}:${size}`
                    : `${pageNum}:${posX}:${posY}:${text}:${size}`;
                }
              } else if (optionData[i].type === "quickSign") {
                const path = optionData[i].url.replace(blog.siteurl, "");
                sign6 += sign6
                  ? `,${pageNum}:${posX}:${posY}:${path}`
                  : `${pageNum}:${posX}:${posY}:${path}`;
              } else if (optionData[i].type === "Signature") {
                sign1 += sign1
                  ? `,${pageNum}:${posX}:${posY}`
                  : `${pageNum}:${posX}:${posY}`;
              }
            }
          } catch (error) {
            console.error("Error processing data:", error);
          }
          initPageNum = initPageNum + numPages;
        } catch (error) {
          console.error("Error fetching template:", error);
        }
      }
    }
    let timestamp = 0;
    let option1 = sign1 + "--*--" + sign3;
    let option2 =
      sign2 +
      "--*--" +
      sign4 +
      "--*--" +
      sign5 +
      "--*--letter--*--" +
      timestamp +
      "--*--" +
      sign6;
    let display_name = "google_" + user.name;
    let body = {
      author_id: user.id,
      author: display_name,
      contact_id: 0,
      pdfData: firstPdfData,
      pdfName: multiplePdfs[0].name,
      option1: option1,
      option2: option2,
      sendPDFType: sendPDFType,
      allObjects: firstAllObjects,
    };
    return body;
  }
  async function sendSignature(
    contact_id = 0,
    cblog = "",
    tw_b_id = 0,
    phone = "",
    email = "",
    cc = ""
  ) {
    if (sending) return;
    sending = true;
    sendPDFRes = false;
    let body = await getSignatureOptions();
    try {
      clipboardTxt = "";
      body.newName = "";
      body.lang = "en";
      body.tw_b_id = tw_b_id;
      body.phone = phone;
      body.email = email;
      body.user_id = shareUserId || (selectedChatUser && selectedChatUser.id) || "";
      body.user_name = shareUserName || (selectedChatUser && selectedChatUser.fullName) || "";
      body.user_caseFileId = merusCaseEnabled ? shareCaseFileId : "";
      body.user_matterId = fluentCaseEnabled ? matterId : "";
      body.cc = cc;
      body.staff_id = user.id;
      body.staff_email = user.email;
      body.staff_name = user.name;
      body.appId = user.appId;
      body.merusUserId = selectedTemplate.merusUserId;
      body.merusActivityTypeId = selectedTemplate.activity_type_id;
      body.fluentCaseTagId = selectedTemplate.fluent_tag_id;
      body.sharepoint = selectedSharepoint;
      body.multiplePdfs = multiplePdfs;
      body.sendEmailSubject = emailSubject;
      body.emailCC = emailCC;
      body.fluentcaseToken = fluentCaseToken;
      body.packetName = selectedPacketName;
      body.send_type = sendPDFType;
      const req = await fetch(
        blog.siteurl + "/wp-admin/admin-ajax.php?action=updateContactPost",
        {
          method: "POST",
          body: JSON.stringify(body),
        }
      );
      let data = await req.json();
      if (data) {
        if ( selectedTemplate.event_type && sendPDFType != "link" ) {

          const date = new Date();
          date.setDate(date.getDate() + parseInt(selectedTemplate.event_number_of_days));

          let newEvent = {
            name: shareUserName + " - " + selectedTemplate.pdfName ,
            details: '',
            creator: '',
            eventDate: ('0' + (date.getMonth() + 1)).slice(-2) + '/' + ('0' + date.getDate()).slice(-2) + '/' + date.getFullYear(),
            eventTime: date.toLocaleTimeString().replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3"),
            eventTimestamp: +date,
            eventType: selectedTemplate.event_type,
            location: '',
            members: [],
            timestamp: Date.now()
          };

          selectedChatUser.events.push(newEvent);

          fetch('https://api.qix.cloud/conversation', {
            method: 'PUT',
            body: JSON.stringify(selectedChatUser),
            headers: {
              'Content-Type': 'application/json',
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          });


        }
      }
      //alert('Sent successfully!.');
      shareEmail = "";
      shareUserId = "";
      shareUserName = "";
      shareCaseFileId = "";
      sendPDFRes = true;
      if (sendPDFType == "link" || sendPDFType == "sms") {
        clipboardTxt = buildSignUrl(data.id);
      }
    } catch (e) {
      // Error handling
    } finally {
      sending = false;
    }
  }
  const copy = () => {
    const app = new CopyClipBoard({
      target: document.getElementById("clipboard"),
      props: { clipboardTxt },
    });

    app.$destroy();
    alert("Copied.");
  };
</script>

<div class="packets-wrapper">
  <!-- Hidden extra search bar when in edit mode -->
  <div style="margin: 10px" class:hidden={true}>
    <input
      placeholder="Search Template"
      type="text"
      class="flex-grow bg-transparent py-1 px-2 w-full"
      style="border: 1px solid;border-radius: 5px;margin-top: 1em;"
      bind:value={searchKeytemplate}
    />
  </div>
  <!-- This section is now hidden since we're using the modal approach -->
  <div class:hidden={true}>
    <div class="header">
      {#each packets as packet}
        <div
          class="packetItem flex"
          class:selectedPack={packet.id == selectedPacketId}
          class:border-green={(packet.id != selectedPacketId) && (tutorialStep == 7 && (tutorialNumber == 3))}
        >
          <span class="cursor-pointer" on:click={selectedPacket(packet)}
            >{packet.packetName}</span
          >
          <span
            class="px-1 cursor-pointer"
            aria-label="Delete"
            on:click={editPacket(packet)}
          >
            <img
              alt=""
              src="img/edit_temp.svg"
              style="width: 20px; margin-left: 8px;margin-top: 3px;"
            />
          </span>
          <span
            class="px-1 cursor-pointer"
            aria-label="Delete"
            on:click={deletePacket(packet.id)}
          >
            <img
              alt=""
              src="img/delete_temp.svg"
              style="width: 20px;margin-top: 3px;"
            />
          </span>
        </div>
        <div
          class="sharePack cursor-pointer"
          class:hidden={packet.id != selectedPacketId}
          class:border-green={tutorialStep == 8 && (tutorialNumber == 3)}
          on:click={sharePacket}
        >
          Share
        </div>
      {/each}
      <div
        class="createPack cursor-pointer"
        class:hidden={packets.length > 0}
        class:border-green={tutorialStep == 4 && (tutorialNumber == 3)}
        on:click={displayCreatePopup}
      >
        Create Packet +
      </div>
      <div
        class="create cursor-pointer"
        class:hidden={packets.length == 0}
        class:border-green={tutorialStep == 6 && (tutorialNumber == 3)}
        on:click={displayCreatePopup}
      >
        +
      </div>
    </div>
  </div>
  <div class="body">
    {#if selectTemplateView}
      <div class="selectTemplate">
        <div style="padding: 10px;">
          <div class="packet-edit-container">
            <input
              placeholder="Search templates..."
              type="text"
              class="packet-search-input"
              bind:value={searchKeytemplate}
            />
            <input
              placeholder="Name the packet..."
              type="text"
              class="packet-name-input"
              bind:value={packetName}
            />
            {#if packetName == "" || templateIds.length < 1}
              <button
                class="packet-save-button disabled"
                >Save</button
              >
            {:else}
              <button
                class="packet-save-button"
                on:click={updatePackets}>Save</button
              >
            {/if}
            <button
              class="packet-cancel-button"
              on:click={cancelPackets}>Cancel</button
            >
          </div>
        </div>
        {#each templates as template}
          {#if searchKeytemplate == "" || template.pdfName
              .toLowerCase()
              .includes(searchKeytemplate.toLowerCase())}
            <div class="signItem">
              <div>
                <div>{template.pdfName}</div>
              </div>
              <div class="action w-full flex items-center">
                <div class="flex items-center">
                  {#if template.selected}
                    <span
                      class="select"
                      on:click={() => unSelectTemplate(template)}
                    >
                      Seleted</span
                    >
                  {:else}
                    <span
                      class="select"
                      on:click={() => selectTemplate(template)}
                      class:border-green={tutorialStep == 5 && (tutorialNumber == 3)}
                      style="color:#185ee0;"
                    >
                      Selete Template
                    </span>
                  {/if}
                </div>
              </div>
            </div>
          {/if}
        {/each}
      </div>
    {/if}
     {#if sharePacketView}
       <div class="sharePacket">
           <!-- Back to Templates Button -->
           <div class="back-to-templates-container" style="margin-bottom: 20px;">
             <button 
               class="back-to-templates-button"
               on:click={backToTemplates}
               title="Return to Templates"
             >
               <img src="/arrow_back.svg" alt="Back" class="back-icon" />
               Back to Templates
             </button>
           </div>
           
           {#if sharePacketView}
           <div class="p-2 flex" style="gap: 20px;">
             <label
               class="flex items-center h-full hover:bg-gray-500
             cursor-pointer px-2 py-1"
               on:click={() => sendSignatureHandle("link")}
             >
               <img
                 alt=""
                 src="link.svg"
                 style="width: 30px; margin-right: 15px;"
               />
               <span>Link</span>
             </label>
             <label
               class="flex items-center h-full hover:bg-gray-500
             cursor-pointer px-2 py-1"
               on:click={() => showShareEmailPanel()}
             >
               <img
                 alt=""
                 src="mail.svg"
                 style="width: 30px; margin-right: 15px;"
               />
               <span>Email</span>
             </label>
           <label
             class="flex items-center h-full hover:bg-gray-500
           cursor-pointer px-2 py-1"
             on:click={() => showShareSMSPanel()}
           >
             <img
               alt=""
               src="sms.svg"
               style="width: 30px; margin-right: 15px;"
             />
             <span>SMS</span>
           </label>
           </div>
         {/if}
        {#if sending}
          <div
            class="flex items-center"
            style="justify-content: space-between; max-width: 200px;"
          >
            <span class:hidden={sendPDFType != "link"}>Generating Link</span>
            <img alt="" src="/loading.gif" style="max-width: 30px;" />
          </div>

        {:else if (sendPDFType == "sms") && !twilioEnabled}
          <div
            class="flex items-center"
            style="justify-content: space-between;"
          >
            <span >You do not have SMS enabled</span>
          </div>
        {:else if sendPDFRes}
          {#if sendPDFType != "link"}
            <div class="w-full half-w-md mx-auto p-2 bg-white rounded-lg">
              <div class="flex items-center gap-2 mb-4">
                <span class="text-lg font-semibold text-gray-700">Sent Successfully</span>
                <CheckMark />
              </div>
              <p class="text-gray-500 text-sm mb-6 leading-relaxed">
                To: {selectedChatUser.fullName} +{selectedChatUser.phone}<br />
                {selectedChatUser.email}
              </p>
              <div class="flex gap-4">
                <a href="https://legalpal.app/chat?chatId={selectedChatUser.id}" target="_blank" class="flex-2 flex items-center justify-center gap-2 px-6 py-2 border-2 border-blue-400 text-blue-500 rounded-2xl hover:bg-blue-50 transition-colors font-medium text-sm">
                  <img alt="conversation icon" src="/img/chatAsset.svg" class="w-5 h-5" />
                  Jump to Conversation
                </a>
                {#if fluentCaseEnabled && selectedChatUser.fluentCaseMattersIds && selectedChatUser.fluentCaseMattersIds.length > 0}
                  <a href="https://app.fluentcase.com/matters/{selectedChatUser.fluentCaseMattersIds[0]}" target="_blank" class="flex-2 flex items-center justify-center gap-2 px-6 py-2 border-2 border-pink-300 text-pink-500 rounded-2xl hover:bg-pink-50 transition-colors font-medium text-sm">
                    <img alt="case file icon" src="/fluentcase.svg" class="w-5 h-5" />
                    Open Case File
                  </a>
                {/if}
              </div>
            </div>
          {:else}
            <div id="clipboard" class="flex flex-col items-center space-y-2">
              <!-- Header -->
              <div class="flex items-center space-x-2 font-semibold text-lg" style="font-family: 'Quicksand', sans-serif;">
              <img
              src="/chat_icon.svg"
              alt="Chat Icon"
              class="w-5 h-5"
              style="color: currentColor;"
              />
              <span style="font-family: 'Quicksand', sans-serif;" >Your link is ready!</span>
              </div>
              
              <!-- Link box -->
                <div 
                on:click={copy} 
                class="flex items-center border border-blue-400 rounded-md px-5 py-3 max-w-full text-xl hover:bg-blue-100" 
                style="font-family: 'Quicksand', sans-serif;"
                >
              <a
              target="_blank"
              rel="noopener noreferrer"
              class="text-blue-600 truncate"
              style="font-family: 'Quicksand', sans-serif;"
              >
              {clipboardTxt}
              </a>
              <img
              src="/copy_icon.svg"
              alt="Copy"
              class="w-5 h-5 cursor-pointer ml-3"
              style="color: currentColor;"
              on:click={copy}
              />
              </div>
            </div> 
          {/if}
        {:else if shareEmailPanel}
          <div class="flex">
            <div class="packets-share-field" style="width: calc(100% - 200px);">
              <Selectbox
                bind:emailSubject={emailSubject}
                bind:emailCC={emailCC}
                bind:friends={friends}
                items={chatUsers}
                type="email"
                placeholder="Enter Email"
                {merusToken}
                bind:merusCaseEnabled={merusCaseEnabled}
                bind:fluentCaseEnabled={fluentCaseEnabled}
                bind:fluentCaseToken={fluentCaseToken}
                bind:selectedChatUser={selectedChatUser}
                bind:checkIfEmailExternal={checkIfEmail}
                appId={user.appId}
                {user}
                on:select={handleChatUserSelect}
                on:enterEmail={handleChatUserEnterEmail}
                on:send={(event) => sendSignatureHandle("email", event)}
                on:itemAdded={handleItemAdded}
                on:itemUpdated={handleItemUpdated}
              />
            </div>
            <!-- {#if checkIfEmail}
              <button
                class="text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded bg-blue-500 hover:bg-blue-700"
                style="display: flex; align-items: center; margin-left: auto;max-height: 35px;"
                on:click={() => sendSignatureHandle("email")}
              >
                <img
                  alt=""
                  src="mail_w.png"
                  style="width: 25px; margin-right: 15px;max-height: 35px;"
                /> Send</button
              >
            {:else}
              <button
                class="text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded"
                style="display: flex; align-items: center; margin-left: auto; background: grey;max-height: 35px;"
                ><img
                  alt=""
                  src="mail_w.png"
                  style="width: 25px; margin-right: 15px;max-height: 35px;"
                /> Send</button
              >
            {/if} -->
          </div>
          {:else if shareSMSPanel}
          <div class="flex">
            <div class="packets-share-field" style="width: calc(100% - 200px);">
              <Selectbox
                bind:emailSubject={emailSubject}
                bind:emailCC={emailCC}
                bind:friends={friends}
                items={chatUsers}
                type="sms"
                placeholder="Select a User"
                {merusToken}
                bind:merusCaseEnabled={merusCaseEnabled}
                bind:fluentCaseEnabled={fluentCaseEnabled}
                bind:fluentCaseToken={fluentCaseToken}
                bind:selectedChatUser={selectedChatUser}
                bind:checkIfEmailExternal={checkIfEmail}
                appId={user.appId}
                {user}
                on:select={handleChatUserSelect}
                on:send={(event) => sendSignatureHandle("sms", event)}
                on:enterEmail={handleChatUserEnterEmail}
                on:itemAdded={handleItemAdded}
                on:itemUpdated={handleItemUpdated}
              />
            </div>
            <!-- {#if selectedChatUser}
              <button
                class="text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded bg-blue-500 hover:bg-blue-700"
                style="display: flex; align-items: center; margin-left: auto;max-height: 35px;"
                on:click={() => sendSignatureHandle("sms")}
              >
                <img
                  alt=""
                  src="sms.svg"
                  style="width: 25px; margin-right: 15px;max-height: 35px;"
                /> Send</button
              >
            {:else}
              <button
                class="text-white font-bold py-1 px-3 md:px-4 mr-3 md:mr-4 rounded"
                style="display: flex; align-items: center; margin-left: auto; background: grey;max-height: 35px;"
                ><img
                  alt=""
                  src="sms.svg"
                  style="width: 25px; margin-right: 15px;max-height: 35px;"
                /> Send</button
              >
            {/if} -->
          </div>
        {/if}
      </div>
    {/if}
  </div>
</div>

<style>
  .packets-wrapper .header {
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .packets-wrapper .create {
    background: #cbd8e8;
    border-radius: 10px;
    width: 30px;
    height: 30px;
    font-size: 2em;
    line-height: 0.7;
    text-align: center;
  }
  .packets-wrapper .createPack {
    background: #cbd8e8;
    border-radius: 10px;
    width: 140px;
    height: 30px;
    padding: 3px 0;
    text-align: center;
  }
  .packets-wrapper .select {
    color: #333;
  }
  .packets-wrapper .packetItem {
    background: #cbd8e8;
    padding: 3px 10px;
    border-radius: 10px;
    margin-right: 10px;
  }
  .packets-wrapper .packetItem.selectedPack {
    background: #185ee0;
    color: #fff;
  }
  .packets-wrapper .sharePack {
    background: #185ee0;
    color: #fff;
    padding: 3px 10px;
    border-radius: 10px;
    margin-right: 10px;
  }
  .packets-wrapper .sharePacket {
    min-height: 230px;
    padding: 10px;
  }

  .packet-edit-container {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
    flex-wrap: wrap;
  }

  .packet-search-input {
    flex: 1;
    background: white;
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 5px;
    font-size: 14px;
    height: 40px;
    box-sizing: border-box;
    min-width: 140px;
  }

  .packet-search-input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  .packet-name-input {
    flex: 0 0 200px;
    background: white;
    padding: 8px 12px;
    border: 1px solid #d1d5db;
    border-radius: 5px;
    font-size: 14px;
    height: 40px;
    box-sizing: border-box;
  }

  @media (max-width: 767px) {
    .packet-edit-container {
      flex-direction: column;
      align-items: stretch;
    }

    .packet-name-input {
      flex: 1 1 auto;
      width: 100%;
      max-width: 100%;
    }

    .packet-search-input {
      width: 100%;
    }

    :global(.packets-share-field) {
      width: 100% !important;
    }
  }

  .packet-name-input:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  .packet-save-button {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #3b82f6;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    height: 40px;
    box-sizing: border-box;
    white-space: nowrap;
  }

  .packet-save-button:hover:not(.disabled) {
    background: #2563eb;
    transform: translateY(-1px);
  }

  .packet-save-button.disabled {
    background: #6b7280;
    cursor: not-allowed;
    opacity: 0.6;
  }

  .packet-cancel-button {
    display: flex;
    align-items: center;
    gap: 6px;
    background: #6b7280;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 5px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    height: 40px;
    box-sizing: border-box;
    white-space: nowrap;
  }

   .packet-cancel-button:hover {
     background: #4b5563;
     transform: translateY(-1px);
   }

   .back-to-templates-container {
     display: flex;
     align-items: center;
     padding: 10px 0;
   }

   .back-to-templates-button {
     display: flex;
     align-items: center;
     gap: 6px;
     background: transparent;
     color: #3b82f6;
     border: none;
     padding: 8px 0;
     font-size: 14px;
     font-weight: 500;
     cursor: pointer;
     transition: all 0.2s;
     height: auto;
     box-sizing: border-box;
     text-decoration: none;
   }

   .back-to-templates-button:hover {
     color: #2563eb;
     text-decoration: none;
   }

   .back-icon {
     width: 16px;
     height: 16px;
     color: #3b82f6;
     filter: brightness(0) saturate(100%) invert(27%) sepia(96%) saturate(1446%) hue-rotate(213deg) brightness(101%) contrast(101%);
   }

   .back-to-templates-button:hover .back-icon {
     filter: brightness(0) saturate(100%) invert(20%) sepia(96%) saturate(1446%) hue-rotate(213deg) brightness(101%) contrast(101%);
   }
 </style>
